import { render } from "./OrderStatus.vue?vue&type=template&id=7e7a3060"
import script from "./OrderStatus.vue?vue&type=script&lang=ts"
export * from "./OrderStatus.vue?vue&type=script&lang=ts"
script.render = render

export default script